<template>
  <div :class="['status-badge', statusClass]">
    <span class="status-dot"></span>
    <span class="status-text">{{ statusText }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useSpotifyAuth } from '@/composables/useSpotifyAuth';

const { isAuthenticated, isPremium } = useSpotifyAuth();

const statusText = computed(() => {
  if (!isAuthenticated.value) {
    return 'Nicht verbunden';
  }
  return isPremium.value ? 'Spotify Premium' : 'Spotify Free';
});

const statusClass = computed(() => {
  if (!isAuthenticated.value) {
    return 'status-disconnected';
  }
  return isPremium.value ? 'status-premium' : 'status-free';
});
</script>

<style scoped lang="scss">
.status-badge {
  @apply inline-flex items-center gap-2;
  @apply px-3 py-1.5 rounded-full text-sm font-medium;
  @apply transition-all duration-300;
}

.status-dot {
  @apply w-2 h-2 rounded-full;
}

.status-disconnected {
  @apply bg-gray-800 text-gray-400;
  
  .status-dot {
    @apply bg-gray-500;
  }
}

.status-free {
  @apply bg-yellow-900 bg-opacity-30 text-yellow-400;
  border: 1px solid rgba($warning, 0.3);
  
  .status-dot {
    @apply bg-yellow-400;
    animation: pulse 2s infinite;
  }
}

.status-premium {
  @apply bg-green-900 bg-opacity-30 text-green-400;
  border: 1px solid rgba($spotify-green, 0.3);
  
  .status-dot {
    @apply bg-green-400;
    background: $spotify-green;
    animation: pulse 2s infinite;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>